import ActiveProfile from './ActiveProfile'
import CompanyProfile from './CompanyProfile'
import EmployerProfile from './EmployerProfile'
import WorkerProfile from './WorkerProfile'
import unescape from 'lodash/unescape'
import { AccountTypes, USER_ACCOUNT_SIMPLE } from '@/constants/user/accountTypes'
import { USER_TYPE_CUSTOMER_COMPANY, USER_TYPE_CUSTOMER_PERSON } from '@/constants/user/roles'
import Avatar from '@/models-ts/user/Avatar'

export default class CommonProfile {
  id: number
  profile: ActiveProfile | WorkerProfile | EmployerProfile | CompanyProfile
  avatar: Avatar | null
  name: string | null
  type: AccountTypes
  avgReviews: number | string | null
  reviewsCount: number | string | null
  is_customer_verified: boolean | null

  constructor(data: Partial<CommonProfile>) {
    Object.assign(this, {
      id: data.id,
      profile: data.profile,
      avatar: data.avatar,
      name: data.name,
      type: data.type,
      avgReviews: data.avgReviews,
      reviewsCount: data.reviewsCount,
      is_customer_verified: data.is_customer_verified,
    })
  }

  static fromServer(data: LX.CommonProfile) {
    const _type = 'type' in data.profile && data.profile.type
    const profile = new Map<boolean, ActiveProfile>([
      [!_type, WorkerProfile.fromServer(data.profile as LX.WorkerProfile)],
      [_type === USER_TYPE_CUSTOMER_PERSON, EmployerProfile.fromServer(data.profile as LX.EmployerProfile)],
      [_type === USER_TYPE_CUSTOMER_COMPANY, CompanyProfile.fromServer(data.profile as LX.CompanyProfile)],
    ]).get(true)

    return new CommonProfile({
      id: data.id,
      type: data.type || USER_ACCOUNT_SIMPLE,
      profile,
      avatar: data.avatar ? Avatar.fromServer(data.avatar) : null,
      name: unescape(data.name || ''),
      avgReviews: Number(('avg_reviews' in data.profile && data.profile.avg_reviews) || 0).toFixed(2),
      reviewsCount: data.reviews_count || 0,
      is_customer_verified: Number(data.is_customer_verified) === 1,
    })
  }
}
